import { useState, useEffect } from "react";
import { resolveImageUrl } from "../lib/api";

export default function LazyImage({ src, alt = "", className = "", style }) {
    const [loaded, setLoaded] = useState(false);
    const [errored, setErrored] = useState(false);
    useEffect(() => {
        setLoaded(false);
        setErrored(false);
    }, [src]);
    return (
        <div className={`relative overflow-hidden bg-[#0a0a0a] ${className}`} style={style}>
            {!loaded && !errored && (
                <div className="absolute inset-0 animate-pulse bg-gradient-to-br from-[#0a0a0a] via-[#141414] to-[#0a0a0a]" />
            )}
            <img
                src={resolveImageUrl(src)}
                alt={alt}
                loading="lazy"
                onLoad={() => setLoaded(true)}
                onError={() => setErrored(true)}
                className={`lazy-img w-full h-full object-cover ${loaded ? "loaded" : ""}`}
                draggable={false}
            />
        </div>
    );
}
